const objetoNavegacao = {
  navegacao: {
    "Dashboard": {
      "Visão Geral": "/",
    },
    "Produtos": () => {
    
    },
    "Clientes": {
      "Visão Geral": {
        "Visão Geral": "/",
      },
    },
    "Finanças": "/",
    "Fiscal": "/",
    "Consultas Rápidas": "/",
    "Analises e Relatórios": "/",
  },
};

export default objetoNavegacao;
